import React from 'react';
import { CheckCircle, Shield, Zap, TrendingUp, Users, Award } from 'lucide-react';
export const FeaturesSection = () => {
  const features = [{
    title: 'Enterprise-Grade Security',
    description: 'Your data is protected with industry-leading security measures and compliance standards.',
    icon: <Shield size={24} className="text-blue-600" data-id="element-84" />
  }, {
    title: 'Rapid Deployment',
    description: 'Get your solutions up and running quickly with our streamlined implementation process.',
    icon: <Zap size={24} className="text-blue-600" data-id="element-85" />
  }, {
    title: 'Scalable Solutions',
    description: 'Our cloud-based applications grow with your business, from startup to enterprise.',
    icon: <TrendingUp size={24} className="text-blue-600" data-id="element-86" />
  }, {
    title: 'Expert Team',
    description: 'Work with certified professionals who have deep expertise in Microsoft and cloud technologies.',
    icon: <Users size={24} className="text-blue-600" data-id="element-87" />
  }, {
    title: 'Industry Recognition',
    description: 'Award-winning solutions that set the standard for innovation and effectiveness.',
    icon: <Award size={24} className="text-blue-600" data-id="element-88" />
  }, {
    title: 'Guaranteed Results',
    description: "We're committed to your success with measurable outcomes and continuous improvement.",
    icon: <CheckCircle size={24} className="text-blue-600" data-id="element-89" />
  }];
  return <section id="features" className="py-20 bg-white" data-id="element-90">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-93">
            Why Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-94">
            We deliver exceptional value through our expertise, technology, and
            commitment to client success.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-8" data-id="element-95">
          {features.map((feature, index) => <div key={index} className="flex" data-id="element-96">
              <div className="flex-shrink-0 mr-4" data-id="element-97">{feature.icon}</div>
              <div data-id="element-98">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-99">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-100">{feature.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};